import { ChangeDetectorRef, Component,OnInit, TemplateRef, ViewChild  } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Api } from 'src/app/services/api';
import { SharedModule } from "src/app/shared/shared-module";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as L from 'leaflet';
import Swal from 'sweetalert2';
import moment from 'moment';

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
  iconUrl: 'assets/leaflet/marker-icon.png',
  shadowUrl: 'assets/leaflet/marker-shadow.png'
});


type CheckinStatus =
  | 'CHECKED_IN'
  | 'NO_CHECKIN'
  | 'TIMEOFF_APPROVED'
  | 'CHECKIN_AND_TIMEOFF'
  | 'DELAY'
  | 'NO_SCHEDULE'
  | 'day-checkins'
  | 'EARLY' | 'ON_TIME' | 'DELAY_RED'
  | 'LATE' | 'YELLOW_TIME' | 'ORANGE_TIME';
interface DayCheckin {
  shift_start: string;
  checkintime?: string | null;
  scheduletime?: string | null;
  status: CheckinStatus;

  attendance_id?: number | null;
  checked?: string | null;

  lat?: string | number | null;
  lng?: string | number | null;
  accuracy?: string | number | null;
  geofence?: string | null;
  sucursal?: string | null;
  comment?: string | null;
}

interface EmployeeCalendar {
  id: number;
  name: string;
  role?: string;
  days: {
    [dateKey: string]: {
      checkins: DayCheckin[];
      timeoff?: any;
    };
  };
}
@Component({
  selector: 'app-my-checkin',
  imports: [MatTableModule, MatDatepickerModule, MatNativeDateModule, MatIconModule, ScrollingModule, SharedModule
  ],
  templateUrl: './my-checkin.html',
  styleUrl: './my-checkin.scss'
})
export class MyCheckin  implements OnInit {
  @ViewChild('attendanceDetailTpl') attendanceDetailTpl!: TemplateRef<any>;

  selectedMonth = new Date();
  selectedSucursal: any;
sucursales:any;
  employees: EmployeeCalendar[] = [];
  daysInMonth: Date[] = [];
  displayedColumns: string[] = ['teacher'];

  modalTitle = '';
  modalEmployeeName = '';
  modalDate!: Date;
  modalCheckins: DayCheckin[] = [];
  modalTimeOff: any = null;
  selectedMapCheckin: DayCheckin | null = null;
loading:boolean = true;
  private dialogRef?: MatDialogRef<any>;
  private leafletMap?: L.Map;
  currentMonth: Date = new Date();
  selectedMonthOVT: Date = new Date();
  firstDay = moment(this.selectedMonthOVT).startOf('month').format('YYYY-MM-DD');
  lastDay = moment(this.selectedMonthOVT).endOf('month').format('YYYY-MM-DD');
  selectedDate: string | null = null; // Tracks the selected date from ReportTable
  constructor(
    private dialog: MatDialog,
    private apiservice: Api,private cdr: ChangeDetectorRef,
  ) {}

myuser:any = localStorage.getItem('userid');


  ngOnInit(): void {
    this.buildDaysInMonth(this.selectedMonth);
    this.loadAttendanceCalendar();
    this.loadSucursales();
  }
  loadSucursales(): void {
    this.apiservice.loadSucursales().subscribe({
      next: (data) => {
        this.sucursales = data;
        // console.log('Sucursales loaded:', this.sucursales);
      },
      error: (error) => {
        console.error('Error fetching sucursales:', error);
        this.apiservice.showMessageWithAnimation('Error al cargar las sucursales', 'error');
      },
      complete: () => {
        // console.log('Sucursales loaded successfully.');
      }
    });
  }
  buildDaysInMonth(date: Date): void {
    const year = date.getFullYear();
    const month = date.getMonth();
    const lastDay = new Date(year, month + 1, 0).getDate();

    this.daysInMonth = [];

    for (let day = 1; day <= lastDay; day++) {
      this.daysInMonth.push(new Date(year, month, day));
    }

    this.displayedColumns = [
      'teacher',
      ...this.daysInMonth.map(d => this.formatDateKey(d))
    ];
  }

  onMonthSelected(event: Date, picker: any): void {
    this.selectedMonth = event;

    console.log(  this.selectedMonth )
    this.buildDaysInMonth(event);
    picker.close();
    this.loadAttendanceCalendar();
  }
DropSuc(){
  console.log('sucursal ', this.selectedSucursal);
      this.loadAttendanceCalendar();
}
  onSelectionChange(value: string): void {
    this.loadAttendanceCalendar(value);
  }

  formatDateKey(date: Date): string {
    return moment(date).format('YYYY-MM-DD');
  }

  getDayCheckins(emp: EmployeeCalendar, date: Date): DayCheckin[] {
    const key = this.formatDateKey(date);
    return emp.days?.[key]?.checkins || [];
  }

  getTooltip(item: DayCheckin): string {
    if (item.status === 'CHECKED_IN') {
      return `${item.shift_start} registrado ${item.checkintime}`;
    }

    if (item.status === 'DELAY') {
      return `${item.shift_start} registrado tarde ${item.checkintime}`;
    }

    if (item.status === 'NO_CHECKIN') {
      return `${item.shift_start} pendiente`;
    }
    if (item.status === 'TIMEOFF_APPROVED' || item.status == 'day-checkins') {
      return `${item.shift_start} time off aprobado`;
    }

    if (item.status === 'CHECKIN_AND_TIMEOFF') {
      return `${item.shift_start} check-in + time off`;
    }
    // console.log(item.status)

    return item.shift_start;
  }

  labelForStatus(status: CheckinStatus): string {
    switch (status) {
      case 'CHECKED_IN':
        return 'Checked In';
      case 'NO_CHECKIN':
        return 'Pending Check-In';
      case 'TIMEOFF_APPROVED':
        return 'Time Off Approved';
      case 'CHECKIN_AND_TIMEOFF':
        return 'Check-In and Time Off';
      case 'DELAY':
        return 'Delayed Check-In';
      default:
        return 'No Schedule';
    }
  }

  openDetail(emp: EmployeeCalendar, date: Date): void {
    const key = this.formatDateKey(date);
    const dayData = emp.days?.[key];

    this.modalEmployeeName = emp.name;
    this.modalDate = date;
    this.modalTitle = `${emp.name} - ${moment(date).format('DD/MM/YYYY')}`;

    this.modalCheckins = dayData?.checkins || [];
    this.modalTimeOff = dayData?.timeoff || null;

    this.selectedMapCheckin =
      this.modalCheckins.find(x => x.lat && x.lng) || null;

    this.dialogRef = this.dialog.open(this.attendanceDetailTpl, {
      width: '520px',
      maxWidth: '95vw'
    });

    this.dialogRef.afterOpened().subscribe(() => {
      if (this.selectedMapCheckin?.lat && this.selectedMapCheckin?.lng) {
        setTimeout(() => this.renderLeafletMap(this.selectedMapCheckin!), 150);
      }
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.destroyLeafletMap();
      this.selectedMapCheckin = null;
    });
  }

  selectCheckinForMap(item: DayCheckin): void {
    if (!item.lat || !item.lng) return;

    this.selectedMapCheckin = item;

    setTimeout(() => {
      this.renderLeafletMap(item);
    }, 100);
  }

  renderLeafletMap(item: DayCheckin): void {
    const lat = Number(item.lat);
    const lng = Number(item.lng);

    if (!lat || !lng || Number.isNaN(lat) || Number.isNaN(lng)) return;

    this.destroyLeafletMap();

    const mapElement = document.getElementById('leafletMap');
    if (!mapElement) return;

    this.leafletMap = L.map('leafletMap', {
      center: [lat, lng],
      zoom: 16
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.leafletMap);

    L.marker([lat, lng])
      .addTo(this.leafletMap)
      .bindPopup(`
        <strong>Check-in</strong><br>
        Schedule: ${item.shift_start || ''}<br>
        Time: ${item.checkintime || ''}<br>
        Accuracy: ${item.accuracy || ''} m
      `)
      .openPopup();

    setTimeout(() => {
      this.leafletMap?.invalidateSize();
    }, 200);
  }

  destroyLeafletMap(): void {
    if (this.leafletMap) {
      this.leafletMap.remove();
      this.leafletMap = undefined;
    }
  }

  normalizeTime(value: any): string | null {
    if (!value) return null;

    const parsed = moment(value, ['HH:mm:ss', 'H:mm:ss', 'HH:mm', 'H:mm'], true);

    if (!parsed.isValid()) return null;

    return parsed.format('HH:mm:ss');
  }

getCheckinStatus(row: any): CheckinStatus {

  const hasSchedule = !!row.shift_start;
  const hasCheckin = !!row.attendance_id;
  const hasTimeoff = !!row.timeoff_id;
  const role = (row.role || '').toLowerCase();
  // console.log(role);

  const isAdmin = role.includes('admin'); // covers Administrador + SysAdmin
//  if(isAdmin){
//   console.log(row);
//  }
  const dayOfWeek = moment(row.calendar_date).day(); // 0 = Sunday
  const isSunday = dayOfWeek === 0;

  // 🔹 TIMEOFF
  if (hasTimeoff && hasCheckin) return 'CHECKIN_AND_TIMEOFF';
  if (hasTimeoff) return 'TIMEOFF_APPROVED';

  // 🔹 CHECKIN (even without schedule)
  if (hasCheckin) {
    if (hasSchedule) {
      const delayed = this.isDelayed(row.shift_start, row.checkintime);
      return delayed;
    }
    return 'CHECKED_IN'; // admin without schedule
  }

  // 🔹 ADMIN WITHOUT SCHEDULE → show ❌ (except Sunday)
  if (!hasSchedule && isAdmin && !isSunday && !hasCheckin) {
    return 'NO_CHECKIN';
  }

  // 🔹 SCHEDULED BUT NO CHECKIN
  if (hasSchedule && !hasCheckin) {
    return 'NO_CHECKIN';
  }

  // 🔹 DEFAULT (no schedule, no checkin, non-admin or Sunday)
  return 'NO_SCHEDULE';
}
getCheckinStatusWORKING(row: any): CheckinStatus {

  const hasSchedule = !!row.shift_start;
  const hasCheckin = !!row.attendance_id;

  // 🔹 No schedule AND no checkin → empty (handled by not pushing)
  if (!hasSchedule && !hasCheckin && !row.timeoff_id) {
    return 'NO_SCHEDULE';
  }

  // 🔹 Timeoff
  if (row.timeoff_id && row.attendance_id) {
    return 'CHECKIN_AND_TIMEOFF';
  }

  if (row.timeoff_id) {
    return 'TIMEOFF_APPROVED';
  }

  // 🔹 Checkin (even without schedule)
  if (hasCheckin) {
    if (hasSchedule) {
      const delayed = this.isDelayed(row.shift_start, row.checkintime);
      return delayed ? 'DELAY' : 'CHECKED_IN';
    }

    // Admin without schedule → still checked in
    return 'CHECKED_IN';
  }

  // 🔹 Scheduled but no checkin
  if (hasSchedule && !hasCheckin) {
    return 'NO_CHECKIN';
  }

  return 'NO_SCHEDULE';
}
  loadAttendanceCalendar(role: string = 'All'): void {
    this.loading = true;
    const monthStart = moment(this.selectedMonth).startOf('month').format('YYYY-MM-DD');
    const monthEnd = moment(this.selectedMonth).endOf('month').format('YYYY-MM-DD');
    let sucursal = this.selectedSucursal;
    const queryOLD = `
      SELECT
        m.id AS schedule_id,
        m.user_id as muserid,
        u.id AS user_id,
        CONCAT(u.nombre, ' ', u.apellidop, ' ', IFNULL(u.apellidom, '')) AS employee_name,
        u.role,
        m.day_name,
        m.shift_start,
        c.calendar_date,
        att.id AS attendance_id,
        att.employee,
        att.checkindate,
        att.checkintime,
        att.scheduletime,
        att.checked,
        att.lat,
        att.lng,
        att.accuracy,
        att.geofence,
        att.comment,
        att.sucursal,
        t.id AS timeoff_id,
        t.dateOff,
        t.requested,
        t.tipodetimeoff,
        t.other_timeoff,
        t.paid,
        t.requeststatus,
        t.approvedbynames,
        u.sucursal_base
      FROM (
        SELECT DATE('${monthStart}') + INTERVAL seq DAY AS calendar_date
        FROM (
          SELECT 0 seq UNION SELECT 1 UNION SELECT 2 UNION SELECT 3 UNION SELECT 4
          UNION SELECT 5 UNION SELECT 6 UNION SELECT 7 UNION SELECT 8 UNION SELECT 9
          UNION SELECT 10 UNION SELECT 11 UNION SELECT 12 UNION SELECT 13 UNION SELECT 14
          UNION SELECT 15 UNION SELECT 16 UNION SELECT 17 UNION SELECT 18 UNION SELECT 19
          UNION SELECT 20 UNION SELECT 21 UNION SELECT 22 UNION SELECT 23 UNION SELECT 24
          UNION SELECT 25 UNION SELECT 26 UNION SELECT 27 UNION SELECT 28 UNION SELECT 29
          UNION SELECT 30 UNION SELECT 31
        ) days
        WHERE DATE('${monthStart}') + INTERVAL seq DAY <= DATE('${monthEnd}')
      ) c
    JOIN sysusers u
       -- ON u.id = m.user_id
      -- AND
      ON u.status = 'Activo'
      left JOIN mycheckin_schedule m
        ON m.user_id = u.id
        and  m.day_name COLLATE utf8mb4_unicode_ci =
          CASE DAYOFWEEK(c.calendar_date)
            WHEN 1 THEN 'domingo'
            WHEN 2 THEN 'lunes'
            WHEN 3 THEN 'martes'
            WHEN 4 THEN 'miercoles'
            WHEN 5 THEN 'jueves'
            WHEN 6 THEN 'viernes'
            WHEN 7 THEN 'sabado'
          END


  LEFT JOIN attendace_employee att
  ON att.employee = u.id
 AND att.checkindate = c.calendar_date
 AND (
   m.id IS NULL
   OR TIME(att.scheduletime) = TIME(STR_TO_DATE(m.shift_start, '%H:%i'))
   OR (att.scheduletime IS NULL AND ABS(
       TIME_TO_SEC(TIME(att.checkintime)) -
       TIME_TO_SEC(TIME(STR_TO_DATE(m.shift_start, '%H:%i')))
     ) <= 7200
   )
 )
      LEFT JOIN timeoff t
      --  ON t.userid = m.user_id
      ON t.userid = u.id
       AND t.dateOff = c.calendar_date
       AND t.requeststatus = 'Aprobado'
      WHERE c.calendar_date BETWEEN DATE('${monthStart}') AND DATE('${monthEnd}')
      AND u.id = ${this.myuser}
      ORDER BY
        employee_name,
        c.calendar_date,
        STR_TO_DATE(m.shift_start, '%H:%i')
    `;
const query = `SELECT
  m.id AS schedule_id,
  m.user_id AS muserid,
  u.id AS user_id,
  CONCAT(u.nombre, ' ', u.apellidop, ' ', IFNULL(u.apellidom, '')) AS employee_name,
  u.role,
  CASE
    WHEN u.role IN ('Administrador', 'SysAdmin', 'RH') THEN fp.day_name
    ELSE m.day_name
  END AS day_name,
  CASE
    WHEN u.role IN ('Administrador', 'SysAdmin', 'RH') THEN fp.shift_start
    ELSE m.shift_start
  END AS shift_start,
  c.calendar_date,
  att.id AS attendance_id,
  att.employee,
  att.checkindate,
  att.checkintime,
  att.scheduletime,
  att.checked,
  att.lat,
  att.lng,
  att.accuracy,
  att.geofence,
  att.comment,
  att.sucursal,
  t.id AS timeoff_id,
  t.dateOff,
  t.requested,
  t.tipodetimeoff,
  t.other_timeoff,
  t.paid,
  t.requeststatus,
  t.approvedbynames,
  u.sucursal_base

FROM (
  SELECT DATE('${monthStart}') + INTERVAL seq DAY AS calendar_date
  FROM (
    SELECT 0 seq UNION SELECT 1 UNION SELECT 2 UNION SELECT 3 UNION SELECT 4
    UNION SELECT 5 UNION SELECT 6 UNION SELECT 7 UNION SELECT 8 UNION SELECT 9
    UNION SELECT 10 UNION SELECT 11 UNION SELECT 12 UNION SELECT 13 UNION SELECT 14
    UNION SELECT 15 UNION SELECT 16 UNION SELECT 17 UNION SELECT 18 UNION SELECT 19
    UNION SELECT 20 UNION SELECT 21 UNION SELECT 22 UNION SELECT 23 UNION SELECT 24
    UNION SELECT 25 UNION SELECT 26 UNION SELECT 27 UNION SELECT 28 UNION SELECT 29
    UNION SELECT 30 UNION SELECT 31
  ) days
  WHERE DATE('${monthStart}') + INTERVAL seq DAY <= DATE('${monthEnd}')
) c

JOIN sysusers u
  ON u.status = 'Activo'

LEFT JOIN mycheckin_schedule m
  ON m.user_id = u.id
  AND LOWER(m.day_name) =
    CASE DAYOFWEEK(c.calendar_date)
      WHEN 1 THEN 'domingo'
      WHEN 2 THEN 'lunes'
      WHEN 3 THEN 'martes'
      WHEN 4 THEN 'miercoles'
      WHEN 5 THEN 'jueves'
      WHEN 6 THEN 'viernes'
      WHEN 7 THEN 'sabado'
    END

LEFT JOIN (
  SELECT employee, 'lunes' AS day_name, sl AS shift_start FROM financial_profile
  UNION ALL
  SELECT employee, 'martes', sm FROM financial_profile
  UNION ALL
  SELECT employee, 'miercoles', sx FROM financial_profile
  UNION ALL
  SELECT employee, 'jueves', sj FROM financial_profile
  UNION ALL
  SELECT employee, 'viernes', sv FROM financial_profile
  UNION ALL
  SELECT employee, 'sabado', ss FROM financial_profile
  UNION ALL
  SELECT employee, 'domingo', sd FROM financial_profile
) fp
  ON fp.employee = u.id
  AND fp.day_name =
    CASE DAYOFWEEK(c.calendar_date)
      WHEN 1 THEN 'domingo'
      WHEN 2 THEN 'lunes'
      WHEN 3 THEN 'martes'
      WHEN 4 THEN 'miercoles'
      WHEN 5 THEN 'jueves'
      WHEN 6 THEN 'viernes'
      WHEN 7 THEN 'sabado'
    END
  AND fp.shift_start IS NOT NULL
  AND u.role IN ('Administrador', 'SysAdmin', 'RH')

LEFT JOIN attendace_employee att
  ON att.employee = u.id
  AND att.checkindate = c.calendar_date
  AND (
    CASE
      WHEN u.role IN ('Administrador', 'SysAdmin', 'RH') THEN fp.shift_start
      ELSE STR_TO_DATE(m.shift_start, '%H:%i')
    END IS NULL

    OR TIME(att.scheduletime) = TIME(
      CASE
        WHEN u.role IN ('Administrador', 'SysAdmin', 'RH') THEN fp.shift_start
        ELSE STR_TO_DATE(m.shift_start, '%H:%i')
      END
    )

    OR (
      att.scheduletime IS NULL
      AND ABS(
        TIME_TO_SEC(TIME(att.checkintime)) -
        TIME_TO_SEC(
          TIME(
            CASE
              WHEN u.role IN ('Administrador', 'SysAdmin', 'RH') THEN fp.shift_start
              ELSE STR_TO_DATE(m.shift_start, '%H:%i')
            END
          )
        )
      ) <= 7200
    )
  )

LEFT JOIN timeoff t
  ON t.userid = u.id
  AND t.dateOff = c.calendar_date
  AND t.requeststatus = 'Aprobado'

WHERE c.calendar_date BETWEEN DATE('${monthStart}') AND DATE('${monthEnd}') AND u.id = ${this.myuser}
ORDER BY
  employee_name,
  c.calendar_date,
  TIME(
    CASE
      WHEN u.role IN ('Administrador', 'SysAdmin', 'RH') THEN fp.shift_start
      ELSE STR_TO_DATE(m.shift_start, '%H:%i')
    END
  );`;
 console.log('Load query ', query)
 let t =``;
    this.apiservice.rawquery('attendanceCalendar', btoa(query)).subscribe({
      next: (rows: any[]) => {
        this.employees = this.transformAttendanceRows(rows || []);
                console.log('Load employee ', rows)

setTimeout(() => {  this.cdr.detectChanges(); this.loading = false; }, 1000);
      },
      error: (err: any) => {
         this.loading = false;
        console.error('Error loading attendance calendar', err);
      }
    });
  }

  transformAttendanceRows(rows: any[]): EmployeeCalendar[] {
    const employeeMap = new Map<number, EmployeeCalendar>();

    rows.forEach(row => {
      // const userId = Number(row.user_id);
      // const userId = Number(row.user_id || row.employee);
      const userId = Number(row.user_id ?? row.employee ?? row.userid);
      const dateKey = moment(row.calendar_date).format('YYYY-MM-DD');
if (!userId) return;
      if (!employeeMap.has(userId)) {
        employeeMap.set(userId, {
          id: userId,
          name: row.employee_name,
          role: row.role,
          days: {}
        });
      }

      const emp = employeeMap.get(userId)!;

      if (!emp.days[dateKey]) {
        emp.days[dateKey] = {
          checkins: [],
          timeoff: row.timeoff_id
            ? {
                id: row.timeoff_id,
                dateOff: row.dateOff,
                requested: row.requested,
                tipodetimeoff: row.tipodetimeoff,
                other_timeoff: row.other_timeoff,
                paid: Number(row.paid),
                requeststatus: row.requeststatus,
                approvedbynames: row.approvedbynames
              }
            : null
        };
      }
const hasSchedule = !!row.shift_start;
const hasCheckin = !!row.attendance_id;
const hasTimeoff = !!row.timeoff_id;
// ONLY push when meaningful
// if (hasSchedule || hasCheckin || hasTimeoff) {
const role = (row.role || '').toLowerCase();
const isAdmin = role.includes('admin');

if (hasSchedule || hasCheckin || hasTimeoff || isAdmin) {

  emp.days[dateKey].checkins.push({
    shift_start: this.normalizeTime(row.shift_start) || row.shift_start,
    checkintime: this.normalizeTime(row.checkintime),
    scheduletime: this.normalizeTime(row.scheduletime),
    status: this.getCheckinStatus(row),

    attendance_id: row.attendance_id,
    checked: row.checked,

    lat: row.lat,
    lng: row.lng,
    accuracy: row.accuracy,
    geofence: row.geofence,
    sucursal: row.sucursal,
    comment: row.comment
  });

}
    });

    return Array.from(employeeMap.values());
  }

 isDelayed(shiftStart: any, checkinTime: any): CheckinStatus {
   if (!shiftStart || !checkinTime) return 'ON_TIME';

   const shift = moment(shiftStart, ['HH:mm:ss', 'H:mm:ss', 'HH:mm', 'H:mm'], true);
   const checkin = moment(checkinTime, ['HH:mm:ss', 'H:mm:ss', 'HH:mm', 'H:mm'], true);

   if (!shift.isValid() || !checkin.isValid()) return 'ON_TIME';

   const diffMinutes = checkin.diff(shift, 'minutes'); // positivo = llegó tarde

       if (diffMinutes <= -15) return 'EARLY';         // >=15 min antes
       if (diffMinutes <= -10) return 'YELLOW_TIME';   // 10–14 min antes
       if (diffMinutes < 0)   return 'ORANGE_TIME';    // 1–9 min antes

       // ✔️ después de hora
       // if (diffMinutes <= 5)  return 'DELAY';          // 0–5 min tarde
      // if (diffMinutes <= 10) return 'DELAY_RED';      // 6–10 min tarde

 return 'LATE';                                  // >10 min
 }

      previousMonth(): void {
          this.selectedMonthOVT = moment(this.selectedMonthOVT).subtract(1, 'month').toDate();
          this.selectedDate = null;
          this.firstDay = moment(this.selectedMonthOVT).startOf('month').format('YYYY-MM-DD');
          this.lastDay = moment(this.selectedMonthOVT).endOf('month').format('YYYY-MM-DD');
         this.selectedMonth = this.selectedMonthOVT;
    console.log(  this.selectedMonth )
    this.buildDaysInMonth(this.selectedMonthOVT);
    this.loadAttendanceCalendar();

          }

        nextMonth(): void {
          this.selectedMonthOVT = moment(this.selectedMonthOVT).add(1, 'month').toDate();
          this.selectedDate = null;
          this.firstDay = moment(this.selectedMonthOVT).startOf('month').format('YYYY-MM-DD');
          this.lastDay = moment(this.selectedMonthOVT).endOf('month').format('YYYY-MM-DD');
         this.selectedMonth = this.selectedMonthOVT;
    console.log(  this.selectedMonth )
    this.buildDaysInMonth(this.selectedMonthOVT);
    this.loadAttendanceCalendar();

        }

        currentMonthLabel(): string {
          return moment(this.selectedMonthOVT).format('MMMM YYYY');
        }
}
